import { updateField } from '@frontend/repository';
import { TransactionTypeSelectV2 } from '@frontend/transaction/select';
import { TransactionType } from '@frontend/transaction/types';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useTransactionTypeConstraintDataInput from './transaction-type-constraint-data-input.controller';

const ID = 'transaction-type-constraint-data-input';
export interface TransactionTypeConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const TransactionTypeConstraintDataInput = (props: TransactionTypeConstraintDataInputProps) => {
    const viewProps = useTransactionTypeConstraintDataInput(props);

    return (
        <TransactionTypeSelectV2
            id={ID}
            required
            value={viewProps.formValues?.type ?? null}
            onSelect={(v) => {
                if (!viewProps.formValues?.type || (v?.value as TransactionType) !== viewProps.formValues.type) {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { type: v.value as TransactionType } : undefined }));
                }
            }}
        />
    );
};

export default TransactionTypeConstraintDataInput;
